import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subject, Subscription } from 'rxjs';
import { CommonService } from 'src/app/providers/common.service';
import { apiLinks } from "../../../../core/api-links/api-links";
import {isEmpty, get, capitalize} from 'lodash';
import { CustomerService } from "../../../../providers/customer.service";
import { InformationModalComponent } from 'src/app/shared/components/information-modal/information-modal.component';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import * as fs from 'file-saver';
import { DownloaderLoaderComponent } from 'src/app/shared/components/downloader-loader/downloader-loader.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-rental-invoice',
  templateUrl: './rental-invoice.component.html',
  styleUrls: ['./rental-invoice.component.scss']
})
export class RentalInvoiceComponent implements OnInit {
  page = 1;
  limit = 20;
  size = 20;
  total: number;
  totalPages: number;
  totalPage: number;
  isPagination = false;
  billingInvoiceListViewSub: Subscription;
  billingInvoiceListData: any;
  viewMode: number = 0;
  isLoading: boolean;
  billingInvoiceListUnFilteredData: any;
  masterCollectionSize: any;
  collectionSize: any;
  viewInvoice: any;
  isDownloadStatus: boolean = false;
  eventsSubject: Subject<void> = new Subject<void>();
  isShow: boolean = false;
  searchTerm: '';
  filterQuery: any;
  statusTypes = [];
  startYear = 2022;
  yearList:Number[] = [];
  // selectedMonth = Number(moment().format("M")) -1;
  selectedMonth;
  selectedYear: any;
  validMonthYear = false;
  modalReference: NgbModalRef;
  paramDestination: any;
  currentInvoiceType = this.router.url.split('/').pop();
  monthList = moment.months().map((data, index) => {
    return {label:data, value: index};
  });
  status = ['COMMITTED','UNCOMMITTED','APPROVED','DECLINED'];
  
  constructor(private commonService: CommonService,
    private messageService: MessageService,
    private CustomerService: CustomerService,
    private ngbModal: NgbModal,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    this.currentInvoiceType = this.router.url.split('?')[0].split('/').pop();
    this.filterQuery = {invoiceType:this.currentInvoiceType};
  
    this.jumpFromCustomersInvoiceGeneration();
    // this.getInvoiceDetails({ isFilter: false, page: this.page, size: this.size });
    this.isLoading = true;
    let selectedYear = Number(moment().format("YYYY"));
    for (let i = this.startYear; i <= selectedYear; i++) {
      this.yearList.push(i);
    } 
  }

  applyFilters(filteredData) {
    // this.getInvoiceList(filteredData);
    console.log('filteredData', filteredData);
    let {data, searchTerm} = filteredData;
    this.searchTerm=searchTerm;
    this.page = 1;
    if(!isEmpty(data)) {
      this.billingInvoiceListData = data.data.items;
      this.viewInvoice = this.billingInvoiceListData.length > 0 ? this.billingInvoiceListData[0] : [];
      this.viewMode = 0;
      this.collectionSize = data.data.totalItems;
      this.total = data.data.totalItems;
    } else {
      this.billingInvoiceListData = this.billingInvoiceListUnFilteredData;
      if(this.billingInvoiceListData){
        this.viewInvoice = this.billingInvoiceListData.length > 0 ? this.billingInvoiceListData[0] : [];
      }
      this.viewMode = 0;
      this.collectionSize = this.masterCollectionSize;
      this.total = this.totalPage;
    }
    if (isEmpty(this.billingInvoiceListData) && !isEmpty(data)) {
      this.messageService.clear();
      this.showNoDataMessage();
    }
  }

  getInvoiceDetails(filter) {
    this.billingInvoiceListViewSub = this.commonService.getCommonHttpClientQueryParams(apiLinks.getAllBillingInvoice, filter).subscribe(res => {
      this.isLoading = false;
      this.billingInvoiceListUnFilteredData = this.billingInvoiceListData = res.data.items;
      this.masterCollectionSize = this.collectionSize = res.data.totalItems;
      this.messageService.clear();
      this.viewInvoice = this.billingInvoiceListData.length > 0 ? this.billingInvoiceListData[0] : [];
      this.viewMode = 0;
      console.log('no data ', isEmpty(this.billingInvoiceListData));
      if (isEmpty(this.billingInvoiceListData)) {
        this.messageService.clear();
        this.showNoDataMessage();
      }
    },
      (err) => {
        console.log('errrrr-------', err);
        this.showAlert(err, "error");
      }
    )
  }

  showNoDataMessage() {
    console.log('showNoDataMessage----------');
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Sorry! No Invoice exists.',
      sticky: true
    });
  }

  showAlert(data, alertType) {
    this.messageService.add({
      severity: alertType,
      summary: data.status,
      detail: data.message,
    });
  }

  jumpFromCustomersInvoiceGeneration() {
    return this.route.queryParams.subscribe(async (param) => {
      if (isEmpty(param)) {
        this.getInvoiceDetails({ isFilter: true, page: this.page, size: this.size, ...this.filterQuery});
      } 
      else {
          this.getInvoiceDetails({ isFilter: true, page: this.page, size: this.size, status: param.status, year:param.year, month:param.month,queryString:param.queryString, ...this.filterQuery });
      }
    });
  }
  getMonthName(value) {
    return this.commonService.getMonthName(value);
  }
  toggleDisplay() {
    this.isShow = !this.isShow;
  }
  refreshPage() {
    // this.refreshUsers$.next(true);
    this.getInvoiceDetails({page:this.page, size: 20, ...this.filterQuery})
  }
  selectedFilter(data, propertyName) {
    this.filterQuery['isFilter'] = true;
    this.filterQuery['size'] = 20;
    this.filterQuery['invoiceType'] =this.currentInvoiceType;
    if(isEmpty(data) && data == '') {
      this.filterQuery[propertyName] = "";
    }
    else if(propertyName === 'status') {
      this.filterQuery[propertyName] = (data);
    }
    else if(propertyName === 'year'){
      this.filterQuery[propertyName] = (data);
    }
    else if(propertyName === 'month'){
      this.filterQuery[propertyName] = (data?.value + 1);
    }
    else if(propertyName === 'queryString') {
      this.filterQuery[propertyName] = data?.data != null ? data?.data : data?.data != undefined ? data?.data : ''
    }
    
    if(this.searchTerm){
      this.filterQuery['queryString'] = this.searchTerm;
    }
    this.page = 1;
    this.getInvoiceDetails( { isFilter: true, page:this.page, ...this.filterQuery});
  }

  clear() {
    this.filterQuery = {'hostResponseCode':'', year:'', month:'', status:'','invoiceType':this.currentInvoiceType};
    this.selectedYear = [];
    this.statusTypes = [];
    this.selectedMonth=[];
    this.eventsSubject.next();
    this.page = 1;
    this.getInvoiceDetails( { isFilter: false, page:this.page, size: this.size, ...this.filterQuery});
  }

  selected(index) {
    this.viewMode = index;
  }

  getUserDetails(invoice) {
    this.viewInvoice = invoice;
  }

  getPage(page: number) {
    this.page = page;
    console.log('this.filterQuery', this.filterQuery);
    this.getInvoiceDetails({ isFilter: false, page: this.page, size: this.size, ...this.filterQuery });
  }

  downLoadISOInvoice() {
    const { isoId, month, year, excelFileLocation } = this.viewInvoice;
    this.downLoadISOInvoiceBill("excel");
  }

  isNull(fileLocation) {
    return fileLocation == "NA";    
  }

  commitInvoice(status) {
    const {month, year, invoiceNumber} = this.viewInvoice;
    let currentMonth = Number(moment().format("M"));
    let currentYear = Number(moment().format("YYYY"));
    let invoiceCommitAlert = `Do you want to ${capitalize(status)} Invoice# `+invoiceNumber;

    let modalRef = this.ngbModal.open(InformationModalComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.header = "Invoice Confirmation";
    if(currentMonth == month && year == currentYear) {
      invoiceCommitAlert = `Do you want to proceed with ${capitalize(status)} invoice of current month (${moment().format("MMM")} - ${currentYear}).`;
      // modalRef.componentInstance.header = `Are you sure?`
    }
    modalRef.componentInstance.body = invoiceCommitAlert;
    modalRef.componentInstance.cancelButton = true;
    modalRef.componentInstance.commitButton = true;
    modalRef.componentInstance.rentalInvoice = true;
    modalRef.componentInstance.commitButtonText = capitalize(status);
    modalRef.componentInstance.invoiceData = this.viewInvoice;
    // modalRef.componentInstance.invoiceStatus = status;
    modalRef.result.then((result) => {
      if (result == 'success') {
        this.showAlert({ status: `${capitalize(status)} Invoice`, message: `Invoice is ${status} Successfully` }, "success");
        this.refreshPage();
      }
    })
  }

  enableApprovalButton(invoiceData) {
    let currentUser = JSON.parse(localStorage.getItem('current_user'));
    return !(get(invoiceData,'invoiceStatus') == 'COMMITTED' && currentUser.userTypeRole === 'FINANCE_ADMIN') || invoiceData?.splitUpJSON?.total==0;
  }
  
  downLoadISOInvoiceBill(fileType) {
    
    this.openLoaderModal();
      this.isDownloadStatus = true;
    this.commonService.getCommonFileDownload(apiLinks.downloadBillInvoicePDF+"/"+this.viewInvoice.id+"/"+fileType).subscribe(data => {
      let downloadURL = window.URL.createObjectURL(data);
      let fileName ="";
      if(fileType == 'pdf') {
        fileName = this.viewInvoice.pdfFileLocation.split("/");
      } else {
        fileName = this.viewInvoice.excelFileLocation.split("/");
      }
      fs.saveAs(downloadURL,fileName[fileName.length -1]);
      this.isDownloadStatus = false;
      this.modalReference.close();
    })
  }

  openLoaderModal(){
    window.scroll(0,0);
    let ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false,
      centered: true,
      size: 'lg',
    };
    this.modalReference =  this.ngbModal.open(DownloaderLoaderComponent, ngbModalOptions);
    this.modalReference.componentInstance.isLoading = true;
    this.modalReference.componentInstance.body = "Downloading";
  }
}
